import axios from 'axios';

const CACVerification = () => {

    // Replace 'YOUR_BEARER_TOKEN' with the actual bearer token you have
    const bearerToken = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnQiOnsiX2lkIjoiNjU0ZTYxZTQxOWUxZjkwMDFjYjg1ZmY2IiwibWVyY2hhbnQiOnsiX2lkIjoiNjU0ZTYxZTQxOWUxZjkwMDFjYjg1ZmY0Iiwib3duZXIiOiI2NTRlNjFlNDE5ZTFmOTAwMWNiODVmZjMiLCJzdWJzY3JpcHRpb25TdGF0dXMiOnsidmFsdWUiOiJmcmVlVHJpYWwiLCJ1cGRhdGVkQXQiOiIyMDIzLTExLTI2VDAwOjAwOjAwLjAxMVoifSwidGFncyI6WyJjYW4tdXNlLWFuYWx5dGljcy13aWRnZXQiLCJjYW4tdXNlLW5pZ2VyaWFuLWJ2biIsImNhbi11c2UtbmlnZXJpYW4tZGwiLCJjYW4tdXNlLW5pZ2VyaWFuLW5pbiIsImNhbi11c2UtbmlnZXJpYW4tdGluIiwiY2FuLXVzZS1uaWdlcmlhbi12aW4iLCJjYW4tdXNlLW5pZ2VyaWFuLWNhYyIsImNhbi11c2UtY3VzdG9tLWZpZWxkcyJdfX0sInVzZXIiOnsiX2lkIjoiNjU0ZTYxZTQxOWUxZjkwMDFjYjg1ZmYzIn0sInNjb3BlIjoidmVyaWZpY2F0aW9uX2Zsb3cgaWRlbnRpdHk6cmVhZCB2ZXJpZmljYXRpb246cmVhZCIsImlhdCI6MTcwMTcwNDQ2MSwiZXhwIjoxNzAxNzA4MDYxLCJpc3MiOiJtYXRpLmlvIn0.cCfyl_10ecSR7DfAIU8d79QzfftvVsGuG6ZwShSBvto';

    
    //implement function to generate metamap token
    const options = {
        method: 'POST',
        url: 'https://api.getmati.com/govchecks/v1/ng/cac',
        headers: {
            accept: 'application/json',
            'content-type': 'application/json',
            Authorization: `Bearer ${bearerToken}`  // Include the bearer token here
        },
        data: {
            // Your request body data goes here
            registrationNumber: '1612023',
            callbackUrl: 'https://norrenberger.com',
            // ...
        }
    };

    axios.request(options)
        .then(function (response) {
            console.log(response);
        })
        .catch(function (error) {
            console.error(error);
        });

    return (<>
        <section>

        </section>
    </>)
}
export default CACVerification